import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { firstValueFrom, from, Observable, switchMap } from 'rxjs';
import {
  CharityFileSourceTypes,
  CharityFileType,
  FileModel,
} from '../models/file.model';
import { ApiResponse } from '../models/api-resoponse';

function blobToDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
  });
}

@Injectable({
  providedIn: 'root',
})
export class FileService {
  private readonly apiBaseUrl = environment.baseApi;
  private readonly httpClient = inject(HttpClient);
  generateLink(
    fileId: string,
    type: CharityFileType = CharityFileType.FILE,
  ): Observable<{ url: string; filename: string }> {
    return this.httpClient.get<{ url: string; filename: string }>(
      `${this.apiBaseUrl}generate-url/${fileId}`,
    );
  }

  getFileAsDataUrl(
    fileId: string,
    type: CharityFileType = CharityFileType.IMAGE,
  ): Observable<string> {
    return this.generateLink(fileId, type).pipe(
      switchMap((res) =>
        this.httpClient.get(res.url, { responseType: 'blob' }),
      ),
      switchMap((blob) => from(blobToDataUrl(blob))),
    );
  }

  uploadFile(
    file: File,
    source: CharityFileSourceTypes,
    type: CharityFileType = CharityFileType.FILE,
  ): Observable<{ id: string }> {
    const formData = new FormData();

    formData.append('file', file, file.name);
    formData.append('type', '' + type);
    formData.append('source', '' + source);
    return this.httpClient.post<{ id: string }>(
      `${this.apiBaseUrl}upload/`,
      formData,
    );
  }

  async download(
    file: FileModel,
    type: CharityFileType = CharityFileType.FILE,
  ) {
    const res = await firstValueFrom(this.generateLink(file.id!, type));
    const url = res.url;
    const fileName = res.filename || file.filename;

    this.httpClient
      .get(url, {
        responseType: 'blob',
      })
      .subscribe((blob) => {
        const objectUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = fileName!;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(objectUrl);
      });
  }
}
